const STOP = new Set(["img", "image", "photo", "pic", "dsc", "final", "edit", "copy", "the", "and", "for", "a", "an", "of", "to", "with", "diy", "jpg", "jpeg", "png", "webp", "heic", "gift", "gifts", "make", "you", "can", "how"]);

const words = (s: string) => s.toLowerCase().replace(/\.[a-z0-9]+$/, "").split(/[^a-z]+/).map((w) => w.replace(/s$/, "")).filter((w) => w.length > 2 && !STOP.has(w));

// Best article for a file name, or null when nothing fits well enough.
export function matchFile<T extends { slug: string; title: string }>(name: string, rows: T[]): T | null {
  const fw = words(name);
  if (!fw.length) return null;
  let best: T | null = null, bestScore = 0, tie = false;
  for (const r of rows) {
    const tw = new Set(words(`${r.title} ${r.slug}`));
    const hits = fw.filter((w) => tw.has(w)).length;
    if (hits > bestScore) { best = r; bestScore = hits; tie = false; } else if (hits && hits === bestScore) tie = true;
  }
  const enough = bestScore >= 2 || (bestScore === 1 && fw.length === 1);
  return enough && !tie ? best : null;
}
